import React, { useState } from 'react';
import classNames from 'classnames';
import ReactImageGallery from 'react-image-gallery';

import { propTypes } from '../../../util/types';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import {
  AspectRatioWrapper,
  Button,
  IconClose,
  IconArrowHead,
  ResponsiveImage,
} from '../../../components';

import './image-gallery.css';
import css from './ListingImageGallery.module.css';
import BrandIconCard from '../../../components/BrandIconCard/BrandIconCard';
import ImgGallery from '../../ImgGallery/ImgGallery';

const IMAGE_GALLERY_OPTIONS = {
  showPlayButton: false,
  disableThumbnailScroll: true,
};
const MAX_LANDSCAPE_ASPECT_RATIO = 2; // 2:1
const MAX_PORTRAIT_ASPECT_RATIO = 4 / 3;

const getFirstImageAspectRatio = (firstImage, scaledVariant) => {
  if (!firstImage) {
    return { aspectWidth: 1, aspectHeight: 1 };
  }

  const v = firstImage?.attributes?.variants?.[scaledVariant];
  const w = v?.width;
  const h = v?.height;
  const hasDimensions = !!w && !!h;
  const aspectRatio = w / h;

  return hasDimensions && aspectRatio >= MAX_LANDSCAPE_ASPECT_RATIO
    ? { aspectWidth: 2, aspectHeight: 1 }
    : hasDimensions && aspectRatio <= MAX_PORTRAIT_ASPECT_RATIO
    ? { aspectWidth: 4, aspectHeight: 3 }
    : hasDimensions
    ? { aspectWidth: w, aspectHeight: h }
    : { aspectWidth: 1, aspectHeight: 1 };
};

const ListingImageGallery = props => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const intl = useIntl();
  const { rootClassName, className, images, imageVariants, thumbnailVariants } = props;
  const thumbVariants = thumbnailVariants || imageVariants;

  const { aspectWidth, aspectHeight } = getFirstImageAspectRatio(images?.[0], imageVariants[0]);

  // ✅ Limit to 4 images when not in fullscreen
  const visibleImages = isFullscreen ? images : images.slice(0, 4);

  const items = visibleImages.map((img, i) => {
    return {
      original: '',
      alt: intl.formatMessage(
        { id: 'ListingImageGallery.imageAltText' },
        { index: i + 1, count: images.length }
      ),
      thumbAlt: intl.formatMessage(
        { id: 'ListingImageGallery.imageThumbnailAltText' },
        { index: i + 1, count: images.length }
      ),
      thumbnail: img.attributes?.variants?.[thumbVariants[0]],
      image: img,
    };
  });

  const imageSizesMaybe = isFullscreen
    ? {}
    : { sizes: `(max-width: 1024px) 100vw, (max-width: 1200px) calc(100vw - 192px), 708px` };

  const renderItem = item => (
    <AspectRatioWrapper
      width={aspectWidth || 1}
      height={aspectHeight || 1}
      className={isFullscreen ? css.itemWrapperFullscreen : css.itemWrapper}
    >
      <div className={css.itemCentering}>
        <ResponsiveImage
          rootClassName={css.item}
          image={item.image}
          alt={item.alt}
          variants={imageVariants}
          {...imageSizesMaybe}
        />
      </div>
    </AspectRatioWrapper>
  );

  const renderThumbInner = item => (
    <div>
      <ResponsiveImage
        rootClassName={css.thumb}
        image={item.image}
        alt={item.thumbAlt}
        variants={thumbVariants}
        sizes="88px"
      />
    </div>
  );

  const onScreenChange = isFull => {
    setIsFullscreen(isFull);
  };

  const renderLeftNav = (onClick, disabled) => (
    <button className={`navLeftGlobal ${css.navLeft}`} disabled={disabled} onClick={onClick}>
      <div className={css.navArrowWrapper}>
        <IconArrowHead direction="left" size="big" />
      </div>
    </button>
  );

  const renderRightNav = (onClick, disabled) => (
    <button className={`navRightGlobal ${css.navRight}`} disabled={disabled} onClick={onClick}>
      <div className={css.navArrowWrapper}>
        <IconArrowHead direction="right" size="big" />
      </div>
    </button>
  );

  const renderFullscreenButton = (onClick, isFullscreen) =>
    isFullscreen ? (
      <Button
        onClick={onClick}
        rootClassName={css.close}
        title={intl.formatMessage({ id: 'ListingImageGallery.closeModalTitle' })}
      >
        <span className={css.closeText}>
          <FormattedMessage id="ListingImageGallery.closeModal" />
        </span>
        <IconClose rootClassName={css.closeIcon} />
      </Button>
    ) : (
      <button className={css.openFullscreen} onClick={onClick}>
        <FormattedMessage
          id="ListingImageGallery.viewImagesButton"
          values={{ count: images.length }}
        />
      </button>
    );

  if (items.length === 0) {
    return <ResponsiveImage className={css.noImage} image={null} variants={[]} alt="" />;
  }

  const classes = classNames(rootClassName || css.root, className);

  // console.log(images[0]?.attributes?.variants?.facebook);

  return (
    <>
      <ImgGallery data={images} />
      {/* <div className="gridCarouselWrapper">
        <ReactImageGallery
          additionalClass={classes}
          items={items}
          renderItem={renderItem}
          renderThumbInner={renderThumbInner}
          onScreenChange={onScreenChange}
          renderLeftNav={renderLeftNav}
          renderRightNav={renderRightNav}
          renderFullscreenButton={renderFullscreenButton}
          {...IMAGE_GALLERY_OPTIONS}
        />

        {images.length > 4 && (
          <div className={css.toggleButtonWrapper}>
            {isFullscreen ? (
              <button
                className={`openFullscreenGlbal ${css.openFullscreen}`}
                onClick={() => setIsFullscreen(false)}
              >
                <FormattedMessage
                  id="ListingImageGallery.showLessButton"
                  defaultMessage="Show less"
                />
                <BrandIconCard type="smallDots" />
                <span>Show Less</span>
              </button>
            ) : (
              <button
                className={`openFullscreenGlbal ${css.openFullscreen}`}
                onClick={() => setIsFullscreen(true)}
              >
                <FormattedMessage
                  id="ListingImageGallery.viewImagesButton"
                  defaultMessage="View all {count} images"
                  values={{ count: images.length }}
                />
                <BrandIconCard type="smallDots" />

                <span>Show All</span>
              </button>
            )}
          </div>
        )}
      </div> */}
    </>
  );
};

export default ListingImageGallery;
